module.exports = __webpack_public_path__ + "static/img/gggggg_27.13e5a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_27.png
// module id = Mpps
// module chunks = 1